import React from 'react';
import { get } from 'lodash';
import { asField } from 'informed';
import Select from 'react-select';
import { FormGroup } from 'reactstrap';
import classnames from 'classnames';

const InputSelect = asField(({ field, fieldState, fieldApi, ...props }) => {
  const { value } = fieldState;
  const { setValue } = fieldApi;
  const {
    col,
    label,
    onChange,
    onFocus,
    multi,
    required,
    selectAll,
    options,
    disabled,
    selected = {},
    marginBottom,
    width,
    widthSelect,
    marginLeftSelect,
    marginTop,
    onInputChange,
    styleAtividade,
    ...rest
  } = props;

  const error = get(fieldState, 'error', []);
  const hasError = Array.isArray(error) && error.length > 0;
  const optionsValue = () => options.map((v) => v.value);


  return (
    <FormGroup
      style={{ color: '#453166', marginBottom: marginBottom, marginTop: marginTop, width: width }}
      className={classnames(col, { 'has-error': hasError })}
    >
      {label && (
        <div style={{display:'flex'}}>
        <label
          style={
            styleAtividade ? {
              color: '#565656',
              fontSize: '12px',
              fontStyle: 'normal',
              fontWeight: 600,
              fontFamily: 'Public Sans',
              marginBottom: '3px',
              lineHeight: "normal",
            } : {
              fontFamily: 'Public Sans',
            fontSize: '14px',
            fontWeight: 500,
            lineHeight: '16px',
            letterSpacing: '0em',
            textAlign: 'left',
              color: '#4A4F58'
            }
          }
          className={classnames({ 'text-danger': hasError })}
        >
          {label}
        </label>
        {
          required ? (<div style={{color:'red', marginLeft:'4px'}}>*</div>):(<></> )
        }
        </div>
      )}

      <Select
        style={
          styleAtividade ? {
            height: '31px',
            background: '#F7F7F7',
            borderRadius: '10px',
            border: '1px solid #DED8D8',
            color: "#383838",
            fontFamily: 'Public Sans',
            fontSize: "12px",
            fontStyle: "normal",
            fontWeight: 400,
            lineHeight: "normal",
          } : {
            width: widthSelect,
            marginLeft: marginLeftSelect
          }
        }
        onChange={(value) => {
          if (multi) {
            if (value) {
              setValue(value.map((x) => x.value));
            } else {
              setValue([]);
            }
          } else {
            if (value) {
              setValue(get(value, 'value'));
            } else {
              setValue('');
            }
          }

          fieldApi.setError(null);
          fieldApi.setTouched();

          if (onChange) onChange(value);
        }}
        onFocus={(value) => {
          if (onFocus) onFocus(value);
        }}
        onInputChange={(value) => {
          if (onInputChange) onInputChange(value);
        }}
        value={value ? value : selected.value}
        noResultsText="Nenhum resultado encontrado."
        placeholder={'Selecione'}
        multi={multi}
        options={options}
        disabled={disabled}
        {...rest}
      />

      {error.map((e) => (
        <p key={e} className="text-danger">
          {e}
        </p>
      ))}
      {multi && selectAll ? (
        <div className="mt-3 float-right">
          <button
            type="button"
            className="btn btn-sm btn-white mr-2"
            onClick={() => setValue([])}
          >
            Remover todos
          </button>
          <button
            style={{ background: '#C099FF' }}
            type="button"
            className="btn btn-sm primary-button"
            onClick={() => setValue(optionsValue())}
          >
            Selecionar Todos
          </button>
        </div>
      ) : (
        null
      )}
    </FormGroup>
  );
});

InputSelect.defaultProps = {
  placeholder: 'Selecione',
  loadingMessage: () => 'Carregando...',
  marginBottom: "1rem",
  marginTop: ""
};

export default InputSelect;
